<template>
  <div class="wrapper">
    <div class="wizard_container" v-if="!showTerms">
      <!-- Wizard tab -->
      <div class="wizard-tab" v-show="tabs[0].tab" v-animate-css="'zoomIn'">
        <div class="logo">
          <img src="@/assets/images/logo/new_logo.svg" />
        </div>
        <div class="wizard_banner">
          <h1>Enhance your consultant profile with A.I.</h1>
          <p>
            Manage Your CV with nice templates, availability
            <br />and get your profile Googable.
          </p>
        </div>
        <div class="account-type">
          <div class="chech-box">
            <input
              type="radio"
              id="consultant"
              class="check-input"
              name="account_type"
              value="1"
              v-model="form_fields.account_type"
            />
            <label for="consultant">I am a consultant</label>
          </div>
          <div class="chech-box">
            <input
              type="radio"
              id="supplier"
              class="check-input"
              name="account_type"
              value="3"
              v-model="form_fields.account_type"
            />
            <label for="supplier"
              >I am a supplier and I want to manage consultants</label
            >
          </div>
        </div>
        <div class="wizard-tab-option">
          <button class="next-btn" @click="nextTab(0)">Next</button>
        </div>
        <div class="wizard-progress">
          <div class="dot-wrapper">
            <div class="doc-item" :class="{ active: tabs[0].finish }"></div>
            <div class="doc-item" :class="{ active: tabs[1].finish }"></div>
          </div>
        </div>
      </div>
      <!-- Wizard tab -->
      <div class="wizard-tab" v-show="tabs[1].tab" v-animate-css="'zoomIn'">
        <div class="logo">
          <img src="@/assets/images/logo/new_logo.svg" />
        </div>
        <p class="wizard-title">Consultant’s information</p>
        <form @submit.prevent="submitForm()">
          <div class="wizard-body">
            <div class="input-group">
              <label>Your Email Address</label>
              <input
                type="email"
                class="form-input"
                v-model="form_fields.email"
              />
            </div>
            <div class="input-group">
              <label>Upload Your CV here</label>
              <upload
                :crop="false"
                @onFileSelected="setCvFile"
                caption="Select file"
                remove_caption="Remove file"
              />
            </div>
          </div>
          <div class="terms-option">
            <input
              type="checkbox"
              id="terms"
              class="check-input"
              name="account_type"
              v-model="form_fields.terms"
            />
            <label for="terms">
              Accept
              <span class="link" @click="showTerms = true"
                >Terms & Conditions</span
              >
            </label>
          </div>
          <div class="wizard-tab-option">
            <consultfied-button
              class="next-btn"
              :disabled="!form_fields.terms"
              :loading="loading"
              >Submit</consultfied-button
            >
          </div>
        </form>
        <div class="wizard-progress">
          <div class="dot-wrapper">
            <div class="doc-item" :class="{ active: tabs[0].finish }"></div>
            <div class="doc-item" :class="{ active: tabs[1].finish }"></div>
          </div>
        </div>
      </div>
      <!-- Wizard tab -->
      <div class="wizard-tab" v-show="tabs[2].tab" v-animate-css="'zoomIn'">
        <div class="logo">
          <img src="@/assets/images/logo/new_logo.svg" />
        </div>
        <p class="content">
          You are now one step closer to have an enhanced Consultant Profile.
          <br />When our security has checked the document, AI will enhance it.
          <br />We will let you know when it’s done through email.
        </p>
        <div class="wizard-tab-option">
          <button class="next-btn" @click="finishWizard()">Finish</button>
        </div>
      </div>
    </div>
    <div class="terms-conditions" v-show="showTerms" v-animate-css="'zoomIn'">
      <div class="widget-body">
        <div class="info-panel">
          <button class="back-btn" @click="showTerms = false">
            <img src="../assets/icons/back__ic.svg" />
            <span>Back</span>
          </button>
          <terms-widget />
          <div class="bottom">
            <button class="btn-back" @click="showTerms = false">Back</button>
          </div>
        </div>
      </div>
    </div>
    <notifications
      group="status"
      animation-type="velocity"
      position="bottom right"
    />
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import TermsWidget from "@/components/TermsWidget.vue";
import upload from "@/components/Partials/Uploader.vue";
import consultfiedButton from "@/components/helper/consultfiedButton.vue";

export default {
  name: "signup",
  components: {
    TermsWidget,
    upload,
    consultfiedButton,
  },
  computed: {},
  watch: {},
  data() {
    return {
      loading: false,
      showTerms: false,
      tabs: [
        { tab: true, finish: true },
        { tab: false, finish: false },
        { tab: false, finish: false },
      ],
      form_fields: {
        account_type: "1",
        email: "",
        cv_file: null,
        terms: true,
      },
    };
  },
  mounted() {},
  methods: {
    finishWizard() {
      let vm = this;
      vm.$router.push({ path: "/" });
    },
    submitForm() {
      let vm = this;
      if (vm.form_fields.email) {
        if (vm.form_fields.cv_file) {
          let form_data = new FormData();
          form_data.append("account_type", vm.form_fields.account_type);
          form_data.append("email", vm.form_fields.email);
          form_data.append("terms", vm.form_fields.terms);
          if (vm.form_fields.cv_file) {
            form_data.append(
              "cv_file",
              vm.form_fields.cv_file,
              vm.form_fields.cv_file.name
            );
          }
          vm.loading = true;
          vm.$store
            .dispatch("AI_WIZARD_SUBMIT_CV", form_data)
            .then((response) => {
              vm.loading = false;
              vm.nextTab(1);
            })
            .catch((error) => {
              vm.loading = false;
              vm.$notify({
                group: "status",
                title: "Something wrong",
                text: "Your cv not sent, Please try again.",
                type: "warn",
                duration: 3000,
              });
            });
        } else {
          // file
          vm.$notify({
            group: "status",
            title: "Something wrong",
            text: "Cv file not selected, Please select it.",
            type: "warn",
            duration: 3000,
          });
        }
      } else {
        //email
        vm.$notify({
          group: "status",
          title: "Something wrong",
          text: "Email field is empty, Please enter your email.",
          type: "warn",
          duration: 3000,
        });
      }
    },
    setCvFile(file) {
      let vm = this;
      vm.form_fields.cv_file = file;
    },
    nextTab(num) {
      let vm = this;
      if (vm.tabs[num]) {
        vm.tabs[num].tab = false;
        vm.tabs[num].finish = true;
      }
      //  ==
      if (vm.tabs[num + 1]) {
        vm.tabs[num + 1].tab = true;
        vm.tabs[num + 1].finish = true;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.wrapper {
  width: 100%;
  position: relative;
  min-height: 100%;

  overflow: hidden;
  background: #f2f2f2 url("../assets/images/backgrounds/logo_stamp2.svg");
  background-size: contain;
  z-index: 999999;
  background-repeat: no-repeat !important;
  background-position: center;
  padding-top: 100px;
  @media (min-width: 300px) and (max-width: 630px) {
    padding-top: 0px;
    background: #fff;
  }
  .wizard_container {
    width: 100%;
    display: flex;
    text-align: center;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    .wizard-tab {
      width: 800px;
      background: #fff;
      padding: 30px;
      @media (min-width: 300px) and (max-width: 630px) {
        width: 100%;
      }
      .wizard_banner {
        display: flex;
        align-items: center;
        flex-direction: column;
        p {
          text-align: center;
          color: #009289;
          width: 500px;
          font-size: 12px;
          margin-top: 10px;
          margin-bottom: 10px;
        }
      }
      .account-type {
        display: flex;
        align-items: flex-start;
        flex-direction: column;
        padding-left: 119px;
        @media (min-width: 300px) and (max-width: 630px) {
          padding-left: 20px;
        }
        .chech-box {
          margin-top: 20px;
          @media (min-width: 300px) and (max-width: 630px) {
            margin-top: 20px;
            display: flex;
            justify-content: flex-start;
            text-align: left;
          }

          .check-input {
            margin-right: 6px;
          }
        }
      }
      .wizard-title {
        margin-top: 15px;
        font-family: "Nunito", sans-serif;
        font-size: 17px;
        font-weight: 800;
      }
      .content {
        margin-top: 50px;
        margin-bottom: 50px;
      }
      .wizard-body {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        margin-top: 15px;
        margin-bottom: 30px;
        padding-left: 100px;
        @media (min-width: 300px) and (max-width: 630px) {
          padding-left: 0px;
        }
        .input-group {
          display: flex;
          flex-direction: column;
          align-items: flex-start;
          margin-bottom: 15px;
          width: 391px;
          @media (min-width: 300px) and (max-width: 630px) {
            width: 100%;
          }
          label {
            font-size: 16px;
          }
          .form-input {
            border: 1px solid #ddd;
            height: 39px;
            border-radius: 5px;
            outline: none;
            padding: 0px 15px;
            @media (min-width: 300px) and (max-width: 630px) {
              width: 100%;
            }
          }
        }
      }
      .terms-option {
        .link {
          color: #1890a9;
        }
        .check-input {
          margin-right: 10px;
        }
      }
      .wizard-tab-option {
        padding-top: 15px;
        display: flex;
        justify-content: center;
        .next-btn {
          width: 214px;
          height: 45px;
          background: transparent
            linear-gradient(
              306deg,
              #0073a2 0%,
              #027a9f 33%,
              #078e98 83%,
              #0a9796 100%
            )
            0% 0% no-repeat padding-box;
          border-radius: 5px;
          color: #fff;
          display: flex;
          justify-content: center;
          align-items: center;
          transition: 500ms ease-in-out;
          &[disabled] {
            background: #ddd;
            color: rgb(145, 145, 145);
            transition: 500ms ease-in-out;
          }
        }
      }
      .wizard-progress {
        display: flex;
        justify-content: center;
        padding-top: 25px;
        .dot-wrapper {
          display: flex;
          .doc-item {
            width: 9px;
            height: 9px;
            border-radius: 50%;
            border: 1px solid #ddd;
            margin-right: 10px;
            &.active {
              width: 10px;
              height: 10px;
              background: #009289 0% 0% no-repeat padding-box;
            }
          }
        }
      }
    }
  }
  .terms-conditions {
    display: flex;
    justify-content: center;
    .widget-body {
      width: 800px;
      background: #fff;
      padding: 20px;
      .back-btn {
        margin-bottom: 20px;
        img {
          margin-right: 5px;
        }
      }
      .bottom {
        padding-top: 30px;
        .btn-back {
          width: 214px;
          height: 45px;
          background: transparent
            linear-gradient(
              306deg,
              #0073a2 0%,
              #027a9f 33%,
              #078e98 83%,
              #0a9796 100%
            )
            0% 0% no-repeat padding-box;
          border-radius: 5px;
          color: #fff;
        }
      }
    }
  }
}
</style>


